<template>
    <div class="mb-3 border-top mt-3 pt-3">
        <b-modal id="comment-modal" size="md" title="Оставить комментарий на этой странице">

            <div class="mb-3">
                <b-form-input size="sm" type="text" v-model="comment.name" placeholder="Ваше имя (обязательно)"/>
            </div>

            <div class="mb-3">
                <b-form-input size="sm" type="text" v-model="comment.email" placeholder="Ваш Email"/>
            </div>

            <div class="mb-3">
                <b-form-textarea size="sm" placeholder="Текст вашего комментария" rows="5" v-model="comment.text">

                </b-form-textarea>
            </div>

            <template v-slot:modal-footer>
                <b-button size="sm" variant="primary" @click="sendComment"><span class="mdi mdi-send"></span> Отправить комментарий</b-button>
            </template>
        </b-modal>
        <div class="container">
            <div class="row">
                <div class="col-6"><h4>Комментарии</h4></div>
                <div class="col-6 text-right">
                    <b-button size="sm" variant="primary" v-b-modal.comment-modal><span class="mdi mdi-comment"></span> Написать комментарий</b-button>
                </div>
                <div class="col-12">
                    <p>Вы можете оставить комментарий на этой странице с пожеланием, замечанием или вопросом. </p>
                </div>
                <div class="col-12">
                    <div v-if="comments.length > 0" class="pt-3">
                        <div class="card mb-3" v-for="(item,index) in comments" :key="index">
                            <div class="card-body">
                                <strong>{{ item.name + ' | ' + item.date_formatted }}</strong>
                                <div class="pt-3" v-html="item.text"></div>

                              <div v-if="typeof item.answers !== 'undefined'" class="pt-3">
                                <div class="card bg-light text-black-50 mb-3" style="font-size: .8rem" v-for="(answeritem,answerindex) in item.answers" :key="answerindex">
                                  <div class="card-body">
                                    <strong>{{ answeritem.name + ' | ' + answeritem.date_formatted }}</strong>
                                    <div class="pt-3" v-html="answeritem.text"></div>

                                  </div>
                                </div>
                              </div>

                            </div>
                        </div>
                    </div>
                    <div v-else class="alert alert-info text-center">
                        На данной странице еще нет ни одного комментария. Вы можете оставить его первым.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from "vuex";

export default {
    name: 'ComponentBaseComments',
    data: () => ({
        comment: {
            name: '',
            email: '',
            text: ''
        },
        comments: []
    }),
    methods: {
        async getComments() {
            this.$store.commit('wait', {state: true, name: 'Отправка комментария'});
            await this.$http
                .post(this.$apiold, {
                    task: 'comments-get',
                    alias: this.alias
                })
                .then(response => {
                    this.$store.commit('wait', {state: false});
                    this.comments = response.data.result
                })
        },
        async sendComment() {
            this.$store.commit('wait', {state: true, name: 'Отправка комментария'});
            await this.$http
                .post(this.$apiold, {
                    task: 'comments-post',
                    alias: this.alias,
                    comment: this.comment
                })
                .then(response => {
                    this.$store.commit('wait', {state: false});
                    const comment = response.data
                    this.$store.commit('alert', comment.messages);

                    if (!comment.error) {
                        this.$bvModal.hide('comment-modal')
                        this.comment.name = ''
                        this.comment.email = ''
                        this.comment.text = ''
                    }
                })
        }
    },
    mounted() {
        this.getComments()
        if (this.user.registered) {
            this.comment.name = this.user.name
            this.comment.email = this.user.email
        }
    },
    computed: {
        ...mapGetters({
            user: 'user'
        }),

        alias: {
            get() {
                return 'calc_' + this.$route.path
            }
        }
    },
    watch: {
        alias: {
            handler: function () {
                this.getComments()
            }
        }
    }
}
</script>